import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { DxDataGridComponent } from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { dxDataGridColumn } from 'devextreme/ui/data_grid';
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { DOMService, PWADetectorService, ScreenService } from '../../../../../shared/services/general';
import { StandingOrderService } from '../../../../../shared/services/ocl';
import { Diagnosis } from '../../../../shared/models/common';
import { DiagnosisService, PatientService } from '../../../../shared/services';
import { TestService } from '../../../../shared/services/test.service';
import {DiagnosisViewModel} from "../../../../../shared/models/ocl";

@Component({
    selector: 'app-standing-order-form',
    templateUrl: './standing-order-form.component.html',
    styleUrls: ['./standing-order-form.component.scss'],
})
export class StandingOrderFormComponent implements OnInit, OnDestroy {
    @ViewChild('dropDownGrid', { static: false }) public dropDownGrid?: DxDataGridComponent;
    @ViewChild('testDropdown', { static: false }) public testDropdown?: DxDropDownBoxComponent;
    public standingOrderForm: UntypedFormGroup;
    public isLoading = false;
    public standingOrderDoneVisible = false;
    public mode: "create" | "update" = 'create';
    public standingOrderId?: number;
    public schedulerId?: number;
    // @ts-ignore
  public pickerDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
    public selectedDiagnosisOnlyForEdit: DiagnosisViewModel[] | undefined = [];
  // @ts-ignore
    public diagnosisDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
  // @ts-ignore
    public alternateDiagnosisDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
    public repeatType: string = '';
    public repeatDataSource: any;
    public repeatOnMonthlyByDateDataSource: number[] = [];
    public initialValueGenerateInAdvance: number = -1;
    public pickerSelectedTestsKey: number[] = [];
    public repeatTypeSelected: string = '';
    public dayOfWeek: any[] = [];
    public repeatOnMonthlyByDateSelected: number[] = [];
    public repeatOnMonthlyByDateSelectedEdit: number[] = [];
    public startDate: Date | number | string  = Date.now();
    public endDate: Date | number | string = Date.now();
    public isPhone: boolean = false;
    public isTablet: boolean = false;
    public isPhoneLandscape: boolean = false;
    public isPhoneOrTablet: boolean = false;
    private onDestroy$: Subject<void> = new Subject<void>();
    private testName: string = '';

    public diagnosesFormRelationColumns: Array<dxDataGridColumn | string> = [
        {
            dataField: 'code',
            width: 100,
            caption: 'Code',
            allowFiltering: true,
            allowSorting: true,
            allowResizing: true,
        } as dxDataGridColumn,
        {
            dataField: 'shortName',
            caption: 'Name',
            allowFiltering: true,
            allowSorting: true,
            allowResizing: true,
        } as dxDataGridColumn,
    ];

    constructor(private fb: UntypedFormBuilder,
                private domService: DOMService,
                private testService: TestService,
                private pwaDetectorService: PWADetectorService,
                public diagnosisService: DiagnosisService,
                public standingOrderService: StandingOrderService,
                private patientService: PatientService,
                public route: ActivatedRoute,
                private renderer: Renderer2,
                private screen: ScreenService
    ) {
        this.standingOrderForm = this.fb.group({
            id: [null],
            patient: [null],
            physician: [null],
            testIds: [null],
            comments: [null],
            diagnoses: [null],
            type: [null],
            repeatEvery: [1],
            generateInAdvance: [null],
            repeatOnMonthlyByDay: [null],
            endType: 'Never',
            after: [1],
            startDate: [(new Date()).toISOString()],
            endDate: [null],
        });

        this.displayTestExpresion = this.displayTestExpresion.bind(this);
    }

    public ngOnInit() {
        this.diagnosisDataSource.next(new DataSource({ store: this.diagnosisService.customStore(this.diagnosisDataSource) }));
        this.repeatOnMonthlyByDateDataSource = Array.from({ length: 31 }, (_, i) => i + 1);
        this.repeatDataSource = new ArrayStore({
            data: [{
                key: 'Minute',
                text: 'By Minutes'
            }, {
                key: 'Hour',
                text: 'Hourly',
            }, {
                key: 'Day',
                text: 'Daily'
            }, {
                key: 'Week',
                text: 'Weekly'
            }, {
                key: 'MonthlyByDay',
                text: 'Monthly by Day'
            }, {
                key: 'MonthlyByDate',
                text: 'Monthly by Date'
            }],
            key: 'key'
        });

        this.isPhone = this.screen.sizes['screen-x-small'];
        this.isPhoneLandscape = this.screen.sizes['screen-small'];
        this.isTablet = this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.isPhone = this.screen.sizes['screen-x-small'];
            this.isTablet = this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
            this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
            this.resizePickerDropDown();
        });

        this.standingOrderForm.get('patient')?.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            this.pickerDataSource.next(new DataSource({
                store: this.testService.customStore(this.pickerDataSource, x.clientId, false, undefined)
            }));
            this.alternateDiagnosisDataSource.next(new DataSource({
                store:
                    this.diagnosisService.customStoreFilteredByPatientId(x.id, this.alternateDiagnosisDataSource),
            }));
        });

        this.standingOrderId = this.pwaDetectorService.isPWA() ?  (this.route.queryParams as any).value.id ?
            // tslint:disable-next-line:radix
            parseInt((this.route.queryParams as any).value.id as string) : undefined :
            // tslint:disable-next-line:radix
            this.route.snapshot.paramMap.get('id') ? parseInt(this.route.snapshot.paramMap.get('id') as string) : undefined;
        if (this.standingOrderId) {
            this.isLoading = true;

            this.standingOrderService.getStandingOrder(this.standingOrderId)
                .pipe(take(1))
                // tslint:disable-next-line:cyclomatic-complexity
                .subscribe(standingOrder => {
                this.standingOrderForm.get('id')?.setValue(standingOrder.id);
                this.patientService.getPatient(standingOrder.patientId)
                    .pipe(take(1))
                    .subscribe(patient => this.standingOrderForm.get('patient')?.setValue(patient));
                this.standingOrderForm.get('physician')?.setValue(standingOrder.physician);
                this.pickerSelectedTestsKey.push(standingOrder.testId);
                this.testName = standingOrder.test;
                this.standingOrderForm.get('comments')?.setValue(standingOrder.requisitionComments);
                this.standingOrderForm.get('diagnoses')?.setValue(standingOrder.diagnosesIds);
                this.selectedDiagnosisOnlyForEdit = standingOrder.diagnoses;
                this.standingOrderForm.get('type')?.setValue(standingOrder.scheduler.isMinute ? 'Minute' : standingOrder.scheduler.type);
                this.standingOrderForm.get('startDate')?.setValue(standingOrder.scheduler.startDate);
                this.startDate = new Date(this.standingOrderForm.get('startDate')?.value);
                this.standingOrderForm.get('repeatEvery')?.setValue(standingOrder.scheduler.repeat);
                this.standingOrderForm.get('generateInAdvance')?.setValue(standingOrder.scheduler.beforeNotificationValue);
                this.schedulerId = standingOrder.scheduler.id;

                if (this.standingOrderForm.get('type')?.value === 'Week' || this.standingOrderForm.get('type')?.value === 'MonthlyByDay') {
                    if (standingOrder.scheduler.sunday) { this.dayOfWeek.push({text: 'Sun'}); }
                    if (standingOrder.scheduler.monday) { this.dayOfWeek.push({text: 'Mon'}); }
                    if (standingOrder.scheduler.tuesday) { this.dayOfWeek.push({text: 'Tue'}); }
                    if (standingOrder.scheduler.wednesday) { this.dayOfWeek.push({text: 'Wed'}); }
                    if (standingOrder.scheduler.thursday) { this.dayOfWeek.push({text: 'Thu'}); }
                    if (standingOrder.scheduler.friday) { this.dayOfWeek.push({text: 'Fri'}); }
                    if (standingOrder.scheduler.saturday) { this.dayOfWeek.push({text: 'Sat'}); }
                }

                if (this.standingOrderForm.get('type')?.value === 'MonthlyByDay') {
                    if (standingOrder.scheduler.first) { this.standingOrderForm.get('repeatOnMonthlyByDay')?.setValue('First'); }
                    if (standingOrder.scheduler.second) { this.standingOrderForm.get('repeatOnMonthlyByDay')?.setValue('Second'); }
                    if (standingOrder.scheduler.third) { this.standingOrderForm.get('repeatOnMonthlyByDay')?.setValue('Third'); }
                    if (standingOrder.scheduler.fourth) { this.standingOrderForm.get('repeatOnMonthlyByDay')?.setValue('Fourth'); }
                    if (standingOrder.scheduler.last) { this.standingOrderForm.get('repeatOnMonthlyByDay')?.setValue('Last'); }
                }

                if (this.standingOrderForm.get('type')?.value === 'MonthlyByDate') {
                    const days = [];
                    if (standingOrder.scheduler.c1) { days.push(1); }
                    if (standingOrder.scheduler.c2) { days.push(2); }
                    if (standingOrder.scheduler.c3) { days.push(3); }
                    if (standingOrder.scheduler.c4) { days.push(4); }
                    if (standingOrder.scheduler.c5) { days.push(5); }
                    if (standingOrder.scheduler.c6) { days.push(6); }
                    if (standingOrder.scheduler.c7) { days.push(7); }
                    if (standingOrder.scheduler.c8) { days.push(8); }
                    if (standingOrder.scheduler.c9) { days.push(9); }
                    if (standingOrder.scheduler.c10) { days.push(10); }
                    if (standingOrder.scheduler.c11) { days.push(11); }
                    if (standingOrder.scheduler.c12) { days.push(12); }
                    if (standingOrder.scheduler.c13) { days.push(13); }
                    if (standingOrder.scheduler.c14) { days.push(14); }
                    if (standingOrder.scheduler.c15) { days.push(15); }
                    if (standingOrder.scheduler.c16) { days.push(16); }
                    if (standingOrder.scheduler.c17) { days.push(17); }
                    if (standingOrder.scheduler.c18) { days.push(18); }
                    if (standingOrder.scheduler.c19) { days.push(19); }
                    if (standingOrder.scheduler.c20) { days.push(20); }
                    if (standingOrder.scheduler.c21) { days.push(21); }
                    if (standingOrder.scheduler.c22) { days.push(22); }
                    if (standingOrder.scheduler.c23) { days.push(23); }
                    if (standingOrder.scheduler.c24) { days.push(24); }
                    if (standingOrder.scheduler.c25) { days.push(25); }
                    if (standingOrder.scheduler.c26) { days.push(26); }
                    if (standingOrder.scheduler.c27) { days.push(27); }
                    if (standingOrder.scheduler.c28) { days.push(28); }
                    if (standingOrder.scheduler.c29) { days.push(29); }
                    if (standingOrder.scheduler.c30) { days.push(30); }
                    if (standingOrder.scheduler.c31) { days.push(31); }

                    this.repeatOnMonthlyByDateSelectedEdit = days;
                }

                switch (standingOrder.scheduler.endType) {
                    case 0:
                        this.standingOrderForm.get('endType')?.setValue('Never');
                        break;
                    case 1:
                        this.standingOrderForm.get('endType')?.setValue('After');
                        this.standingOrderForm.get('after')?.setValue(standingOrder.scheduler.after);
                        break;
                    case 2:
                        this.standingOrderForm.get('endType')?.setValue('On');
                        this.standingOrderForm.get('endDate')?.setValue(standingOrder.scheduler.endDate);
                        this.endDate = new Date(this.standingOrderForm.get('endDate')?.value);
                        break;
                }

                this.isLoading = false;
            });
        } else {
            const currentDate = new Date();
            currentDate.setHours(0);
            currentDate.setMinutes(0);
            currentDate.setSeconds(0);
            this.standingOrderForm.get('startDate')?.setValue(currentDate);
            this.startDate = new Date(currentDate);
        }
    }

    public canSave(): boolean {
        const repeatSelected = this.standingOrderForm.get('type')?.value;

        if (this.standingOrderForm.get('type')?.value == null) return false;
        if (this.pickerDataSource === undefined) return false;
        if (this.pickerSelectedTestsKey === null || this.pickerSelectedTestsKey.length === 0) return false;
        if (repeatSelected === undefined || repeatSelected === null) return false;
        if (this.standingOrderForm.get('repeatEvery')?.value < 1) return false;
        if (this.standingOrderForm.get('startDate')?.value === null) return false;
        if (repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay') {
            if (this.dayOfWeek.length === 0) return false;
        }
        if (repeatSelected === 'MonthlyByDay') {
            if (this.standingOrderForm.get('repeatOnMonthlyByDay')?.value === null) return false;
        }
        if (repeatSelected === 'MonthlyByDate') {
            if (this.repeatOnMonthlyByDateSelected.length === 0) return false;
        }
        if (this.standingOrderForm.get('endType')?.value === 'After') {
            if (this.standingOrderForm.get('after')?.value <= 0) return false;
        }
        if (this.standingOrderForm.get('endType')?.value === 'On') {
            if (this.standingOrderForm.get('endDate')?.value === null) return false;
            if (new Date(this.standingOrderForm.get('startDate')?.value) > new Date(this.standingOrderForm.get('endDate')?.value)) return false;
        }
        
        return true;

        return this.standingOrderForm.get('type')?.value !== null &&
            this.pickerDataSource !== undefined && this.pickerSelectedTestsKey !== null && this.pickerSelectedTestsKey.length > 0 &&
            repeatSelected !== undefined && repeatSelected !== null && this.standingOrderForm.get('repeatEvery')?.value >= 1 &&
            this.standingOrderForm.get('startDate')?.value !== null &&
            (repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? this.dayOfWeek.length > 0 : true) &&
            (repeatSelected === 'MonthlyByDay' ? this.standingOrderForm.get('repeatOnMonthlyByDay')?.value !== null : true) &&
            (repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.length > 0 : true) &&
            (this.standingOrderForm.get('endType')?.value === 'After' ? this.standingOrderForm.get('after')?.value > 0 : true) &&
            (this.standingOrderForm.get('endType')?.value === 'On' ? this.standingOrderForm.get('endDate')?.value !== null &&
                new Date(this.standingOrderForm.get('startDate')?.value) <= new Date(this.standingOrderForm.get('endDate')?.value) : true);
    }

    // tslint:disable-next-line:cyclomatic-complexity
    public submit() {
        this.isLoading = true;
        const dayOfWeekSelected = this.dayOfWeek.map(x => x.text);
        const repeatSelected = this.standingOrderForm.get('type')?.value;
        const standingOrder = {
            id: this.standingOrderId,
            patientId: this.standingOrderForm.get('patient')?.value.id,
            physicianId: this.standingOrderForm.get('physician')?.value ? this.standingOrderForm.get('physician')?.value.id : null,
            testId: this.pickerSelectedTestsKey[0],
            test: this.testName,
            diagnosesIds: this.standingOrderForm.get('diagnoses')?.value,
            requisitionComments: this.standingOrderForm.get('comments')?.value,
            scheduler: {
                id: this.schedulerId,
                startDate: new Date(this.standingOrderForm.get('startDate')?.value),
                type: repeatSelected === 'Minute' ? 'Hour' : repeatSelected,
                repeat: this.standingOrderForm.get('repeatEvery')?.value,
                beforeNotificationValue: this.standingOrderForm.get('generateInAdvance')?.value,
                isMinute: repeatSelected === 'Minute',
                sunday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Sun') : null,
                monday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Mon') : null,
                tuesday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Tue') : null,
                wednesday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Wed') : null,
                thursday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Thu') : null,
                friday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Fri') : null,
                saturday: repeatSelected === 'Week' || repeatSelected === 'MonthlyByDay' ? dayOfWeekSelected.includes('Sat') : null,
                first: repeatSelected === 'MonthlyByDay' ? this.standingOrderForm.get('repeatOnMonthlyByDay')?.value === 'First' : null,
                second: repeatSelected === 'MonthlyByDay' ? this.standingOrderForm.get('repeatOnMonthlyByDay')?.value === 'Second' : null,
                third: repeatSelected === 'MonthlyByDay' ? this.standingOrderForm.get('repeatOnMonthlyByDay')?.value === 'Third' : null,
                fourth: repeatSelected === 'MonthlyByDay' ? this.standingOrderForm.get('repeatOnMonthlyByDay')?.value === 'Fourth' : null,
                last: repeatSelected === 'MonthlyByDay' ? this.standingOrderForm.get('repeatOnMonthlyByDay')?.value === 'Last' : null,
                endType: this.standingOrderForm.get('endType')?.value === 'Never' ? 0 : this.standingOrderForm.get('endType')?.value === 'After' ? 1 : 2,
                after: this.standingOrderForm.get('endType')?.value === 'After' ? this.standingOrderForm.get('after')?.value : null,
                endDate: this.standingOrderForm.get('endType')?.value === 'On' ? (new Date(this.standingOrderForm.get('endDate')?.value)) : null,
                c1: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(1) : null,
                c2: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(2) : null,
                c3: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(3) : null,
                c4: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(4) : null,
                c5: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(5) : null,
                c6: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(6) : null,
                c7: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(7) : null,
                c8: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(8) : null,
                c9: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(9) : null,
                c10: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(10) : null,
                c11: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(11) : null,
                c12: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(12) : null,
                c13: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(13) : null,
                c14: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(14) : null,
                c15: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(15) : null,
                c16: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(16) : null,
                c17: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(17) : null,
                c18: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(18) : null,
                c19: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(19) : null,
                c20: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(20) : null,
                c21: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(21) : null,
                c22: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(22) : null,
                c23: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(23) : null,
                c24: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(24) : null,
                c25: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(25) : null,
                c26: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(26) : null,
                c27: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(27) : null,
                c28: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(28) : null,
                c29: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(29) : null,
                c30: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(30) : null,
                c31: repeatSelected === 'MonthlyByDate' ? this.repeatOnMonthlyByDateSelected.includes(31) : null
            }
        };

        if (this.standingOrderId) {
            // @ts-ignore
            this.standingOrderService.update(standingOrder).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
                notify('Standing Order Updated!', 'success');
                this.isLoading = false;
                this.mode = 'update';
                this.standingOrderDoneVisible = true;
            });
        } else {
            // @ts-ignore
            this.standingOrderService.create(standingOrder).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
                notify('Standing Order Created!', 'success');
                this.isLoading = false;
                this.standingOrderDoneVisible = true;
            });
        }


    }

    public resizePickerDropDown() {
        const element = this.domService.getElementsByClassname('dx-overlay-wrapper dx-dropdowneditor-overlay dx-popup-wrapper').item(0) as HTMLElement;
        if (element) {
            if (this.isTablet || this.isPhoneLandscape) {
                this.renderer.setStyle(element, 'width', '300px');
                this.renderer.setStyle(element.firstChild, 'width', '300px');
                this.renderer.setStyle(element.firstChild?.firstChild, 'width', '300px');
            } else {
                this.renderer.setStyle(element, 'width', '580px');
                this.renderer.setStyle(element.firstChild, 'width', '580px');
                this.renderer.setStyle(element.firstChild?.firstChild, 'width', '580px');
            }
            this.renderer.setStyle(element, 'height', '100%');
            this.renderer.setStyle(element.firstChild, 'height', '100%');
            this.renderer.setStyle(element.firstChild?.firstChild, 'height', '100%');
        }

        if (this.dropDownGrid !== undefined) {
            this.dropDownGrid.instance.clearFilter();
        }
    }

    public preventDefault(e: any) {
        e.preventDefault();
    }

    public displayTestExpresion(item: any) {
        return item ? item.name : this.testName;
    }

    public onRepeatChange(e: any) {
        this.repeatTypeSelected = e.selectedItem.text;
        switch (e.selectedItem.text) {
            case 'By Minutes':
                this.repeatType = ' minutes(s)';
                this.initialValueGenerateInAdvance = 24;
                break;
            case 'Hourly':
                this.repeatType = ' hour(s)';
                this.initialValueGenerateInAdvance = 24;
                break;
            case 'Daily':
                this.repeatType = ' day(s)';
                this.initialValueGenerateInAdvance = 30;
                break;
            case 'Weekly':
                this.repeatType = ' week(s)';
                this.initialValueGenerateInAdvance = 12;
                break;
            case 'Monthly by Day':
            case 'Monthly by Date':
                this.repeatType = ' month(s)';
                this.initialValueGenerateInAdvance = 24;
                break;
        }
    }

    public dayOfWeekChange(e: any) {
        if (e.addedItems.length > 0) {
            this.dayOfWeek.push(e.addedItems[0].text);
        } else if (e.removedItems.length > 0) {
            const index = this.dayOfWeek.findIndex(x => x === e.removedItems[0].text);
            this.dayOfWeek.splice(index, 1);
        }
    }

    public diagnoseChanged(diagnoses: Diagnosis) {
        this.standingOrderForm.get('diagnoses')?.setValue(diagnoses);
    }

    public get IsPatientSelected(): boolean {
        return this.standingOrderForm.get('patient')?.value !== null;
    }

  public convertToFormControl(absCtrl: AbstractControl | null): UntypedFormControl {
    return absCtrl as UntypedFormControl;
  }

    public endTypeChange(e: any) {
        if (e === 'On') {
            const currentDate = new Date();
            currentDate.setHours(0);
            currentDate.setMinutes(0);
            currentDate.setSeconds(0);
            this.standingOrderForm.get('endDate')?.setValue(currentDate);
            this.endDate = new Date(currentDate);
        } else {
            this.standingOrderForm.get('endDate')?.setValue(null);
            this.endDate = Date.now();
        }
    }

    public startDateChange(e: any) {
        this.startDate = new Date(e);
    }

    public endDateChange(e: any) {
        this.endDate = new Date(e);
    }

    public onDateReady(e: any) {
        const element = e.element;
        if (e.component._pickerType === 'native') {
            const button = element.querySelector('.dx-texteditor-buttons-container');
            const input = element.querySelector('.dx-texteditor-input');
            this.renderer.setStyle(button, 'display', 'none');
            this.renderer.setStyle(input, 'padding-right', '5px');
        }
    }

    public testSelectionChanged() {
        this.testDropdown?.instance.close();
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
